import backend from 'utils/backend'
import { flatten } from 'utils/helpers'
import { trackFunderSearchFacet } from 'utils/mixpanel'

import { mapResponseToFacetsData, updateDocCount } from './helpers'
import { debouncedFunderSearchByParams, searchFundersByParams } from './search'
import { setPageNumber } from './searchPagination'

export const SET_SELECTED_FACETS = 'SET_SELECTED_FACETS'
export const FACET_RESULTS_FAILURE = 'FACET_RESULTS_FAILURE'
export const RESET_FACET_FILTERS = 'RESET_FACET_FILTERS'
export const SET_FACETS = 'SET_FACETS'

export const getFacets = () => async dispatch => {
  try {
    const { data } = await backend.get('api/facets/')

    dispatch({ type: SET_FACETS, payload: { facets: data } })
  } catch (err) {
    console.log({ err })
  }
}

export const syncSelectedFacets = (dispatch, getState) => {
  const {
    facets,
    facets: { selected }
  } = getState()

  // When syncing URL to redux store only id and facetType are available
  // in the URL so a manual lookup to store for name is needed
  const lookupName = ({ facetType, id, name }) => {
    const allFacets = flatten(facets[facetType] || [])
    const facet = allFacets.find(facet => facet.id === id)
    return facet ? facet.name : name
  }

  const data = selected.map(facet => (facet.name ? facet : { ...facet, name: lookupName(facet) }))

  dispatch({ type: SET_SELECTED_FACETS, payload: { data } })
}

export const setSelectedFacets =
  (selectedFacets = []) =>
  dispatch => {
    // Remove duplicates
    const data = selectedFacets.filter(
      (item, index, self) =>
        index === self.findIndex(i => i.id === item.id && i.facetType === item.facetType)
    )

    dispatch({ type: SET_SELECTED_FACETS, payload: { data } })
  }

export const selectFacet =
  ({ id, name, facetType, parents }) =>
  async (dispatch, getState) => {
    const {
      facets: { selected }
    } = getState()

    if (selected.find(facet => facet.id === id && facet.facetType === facetType)) {
      return
    }

    const rawData =
      facetType === 'regions'
        ? selected.concat({ id, name, facetType }, parents || [])
        : selected.concat({ id, name, facetType })

    // Remove duplicates
    const data = rawData.filter(
      (item, index, self) =>
        index === self.findIndex(i => i.id === item.id && i.facetType === item.facetType)
    )

    dispatch({ type: SET_SELECTED_FACETS, payload: { data } })
    debouncedFunderSearchByParams(dispatch)
    dispatch(setPageNumber(1))

    await trackFunderSearchFacet({ id, facetType, selected })
  }

export const unSelectFacet =
  ({ id, facetType }) =>
  (dispatch, getState) => {
    const {
      facets: { selected }
    } = getState()

    const data = selected.filter(facet => facet.id !== id || facet.facetType !== facetType)

    dispatch({ type: SET_SELECTED_FACETS, payload: { data } })
    debouncedFunderSearchByParams(dispatch)
    dispatch(setPageNumber(1))
  }

export const resetFacetFilters = () => ({
  type: RESET_FACET_FILTERS
})

export const resetFacetFiltersAndReload = () => dispatch => {
  dispatch(resetFacetFilters())
  dispatch(setPageNumber(1))
  // refetch results after resetting filters
  dispatch(searchFundersByParams())
}

export const setFacets = facetCountData => async (dispatch, getState) => {
  const { facets } = getState()

  const updatedFacetsData = mapResponseToFacetsData(facetCountData)
  const updatedFacets = updateDocCount(updatedFacetsData, facets)

  dispatch({
    type: SET_FACETS,
    payload: { facets: updatedFacets }
  })
}
